import React, { PropsWithChildren } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';
import { Icon } from 'types/shared/Icon';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';
import { wrapTrademarkSuperscript } from '../../utils/cob-utils';
import { Button, Title } from '../../importCL';
import Accordion from '../../component-library/molecules/Accordion';
import { AccordionEntry } from '../../component-library/molecules/Accordion/components/AccordionItem';
interface IAccordionItem {
    icon?: Icon;
    topic: string;
    subtopic: string;
}

interface IAccordionProps extends MappedComponentProperties {
    title?: string;
    showingHR?: boolean;
    showingIcons?: boolean;
    iconSize?: 'utility' | 'badge';
    openFirst?: boolean;
    accordionItems?: IAccordionItem[];
    backgroundColor?: 'light-grey' | 'white';
    borderEnabled?: boolean;
    expandOnLoad?: boolean;
    link?: string;
    linkText?: string;
    usingAccordionCF?: boolean;
    cfAccordionItems?: IAccordionItem[];
}

export const AccordionEditConfig = {
    emptyLabel: 'Accordion',
    isEmpty: (props: PropsWithChildren<IAccordionProps>) => {
        return !props || !props.accordionItems || !props.accordionItems.length;
    },
};

const AemAccordion = (props: PropsWithChildren<IAccordionProps>): JSX.Element => {

    const mapAemToClAccordionItems = (accordionItems: IAccordionItem[]) :AccordionEntry[] =>
        accordionItems.map(({ topic, subtopic, icon}) => ({
            title: transformHTMLParserLinks(topic),
            content: transformHTMLParserLinks(subtopic),
            icon: {
                ...icon,
                size: props.iconSize,
            },
        }));

    return (
        <div id='accordion'>
            {props.title && 
                <Title tag='h2' align='center' showHr={props.showingHR}>{transformHTMLParserLinks(props.title)}</Title> 
            }
            <Accordion
                id='accordion' 
                firstOpen={props?.openFirst} 
                disableBorder={!props.borderEnabled}
                backgroundColor={props.backgroundColor}
                enableIcons={props.showingIcons}
                openAllOnLoad={props.expandOnLoad}
                items={props.usingAccordionCF && props.cfAccordionItems && props.cfAccordionItems.length > 0 ? 
                    mapAemToClAccordionItems(props.cfAccordionItems) : mapAemToClAccordionItems(props.accordionItems)
                }
            >
            </Accordion>
            {props.link && props.linkText && 
                <div className='flex justify-center'>
                    <Button variant='link' href={props.link} size='medium'>{transformHTMLParserLinks(wrapTrademarkSuperscript(props.linkText))}</Button>
                </div>
            }
        </div>
    );
};

export default AemAccordion;